<template>
  <div>
    <el-row>
      <rabbey-toolbox
        filterables
        :call-new="callNew"
        @filter-search="search = $event"
      >
        <div class="box mr-5">
          <el-button
            title="Actualizar"
            round
            type="primary"
            icon="el-icon-refresh"
            size="mini"
            @click="handleRefresh()"
          ></el-button>
        </div>
        <div class="mr-5">
          <el-tooltip content="Tipo Pronostico" placement="top" effect="light">
            <el-select
              v-model="typePronostico"
              placeholder="Pronostico"
              @change="handlerPronostic"
              size="mini"
            >
              <el-option
                v-for="item in typePronosticoList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-tooltip>
        </div>
        <div class="mr-5">
          <el-tooltip content="Año" placement="top" effect="light">
            <YearsComponent
              ref="yearSelector"
              @change="handleryear"
              :initial="2014"
              :max="yearMax"
              class="box-item"
              size="mini"
              v-model="year"
            />
          </el-tooltip>
        </div>
        <div class="mr-5">
          <el-tooltip content="Compañia" placement="top" effect="light">
            <el-select
              v-model="companyFilter"
              class="box-item"
              size="mini"
              clearable
              @change="handleCompanyChange"
            >
              <el-option
                v-for="company in companys"
                :key="company.value"
                :label="company.label"
                :value="company.value"
              ></el-option>
            </el-select>
          </el-tooltip>
        </div>
        <div class="mr-5">
          <el-tooltip content="Estado" placement="top" effect="light">
            <el-select v-model="state" size="mini" @change="handleRefresh">
              <el-option
                v-for="state in states"
                :key="state.value"
                :label="state.label"
                :value="state.value"
              >
              </el-option>
            </el-select>
          </el-tooltip>
        </div>
      </rabbey-toolbox>
    </el-row>

    <el-card>
      <el-row>
        <el-col>
          <rabbey-table-3
            key-search="Concept"
            row-key="Id"
            :data="rows"
            :border="true"
            :fit="true"
            :search="search"
            :columns="columns"
            :loading="loading"
            :paginate-fromApi="false"
            :highlight-current-row="true"
            :class-table="{
              'table-box': true,
              'card-base': true,
              'card-shadow--medium': false
            }"
            :default-expand-all="false"
            :actions="actions"
            :conditional-actions="({ row }) => row.Id > 0"
            :row-class-name="tableRowClassName"
            :stripe="false"
            :pagination-bind="{ hideOnSinglePage: true }"
            :element-loading-text="loadingText"
            @rtable-push-action="handleCommand"
          >
          </rabbey-table-3>
        </el-col>
      </el-row>
    </el-card>

    <RowCashFlowForm ref="rowCashFlowForm" @refresh="onRefresh" :year="year" />
    <AddAccount ref="addAccount" @refresh="onRefresh" :year="year" />
    <ViewAccounts
      ref="viewAccounts"
      :month="DetailMonth"
      :year="year"
      :typePronostico="typePronostico"
      @refresh="onRefresh"
    />
    <CashFlowActiveContractsDetails
      :visible="showActiveContracts"
      @updateVisible="($event) => OnCloseContractsDetails($event)"
    />
  </div>
</template>

<script>
import { LIST_COMPANYS } from "@/const";
import { Months } from "@/helpers/MonthsColumns";
import { getSummaries } from "@/helpers/TableRabbeyTools";

import RowCashFlowForm from "./components/RowCashFlowForm.vue";
import AddAccount from "./components/AddAccount.vue";
import ViewAccounts from "./components/ViewAccounts.vue";
import YearsComponent from "@/components/Global_System/YearsComponent.vue";
import CashFlow2Hyperlink from "@/components/functionals/CashFlow2Hyperlink.vue";
import CashFlowActiveContractsDetails from "@/views/modules/projects/CashFlowActiveContractsDetails.vue";

const yearNow = new Date().getFullYear();

export default {
  name: "CashFlow2",
  components: {
    RowCashFlowForm,
    AddAccount,
    ViewAccounts,
    YearsComponent,
    CashFlowActiveContractsDetails
  },
  data() {
    return {
      months: Months,
      DetailMonth: Number,
      loading: false,
      loadingText: "Cargando...",
      year: yearNow,
      yearMax: yearNow + 5,
      companyFilter: "ALL",
      companys: LIST_COMPANYS,
      state: "Todos",
      showActiveContracts: false,
      typePronostico: 1,
      states: [
        {
          label: "Todos",
          value: 3
        },
        {
          label: "Ejecutados",
          value: 1
        },
        {
          label: "No Ejecutados",
          value: 0
        }
      ],
      headFormat: {
        backgroundColor: "#409eff",
        color: "#0b0b0c",
        fontWeight: "bold"
      },
      rows: [],
      itemsIngreso: [],
      itemsEgreso: [],
      itemsDisponible: [],
      search: "",
      actions: [
        {
          label: "Agregar Cuenta",
          command: "add-account",
          icon: "el-icon-plus",
          condition: (row) => row.Id != 99999
        },
        {
          label: "Ver Cuentas",
          command: "view-accounts",
          icon: "el-icon-view"
        },
        {
          label: "Editar Renglon",
          command: "edit-row-cashflow",
          icon: "el-icon-edit",
          condition: (row) => row.Id != 99999
        },
        {
          label: "Eliminar Renglon",
          command: "delete-row-cashflow",
          icon: "el-icon-delete",
          condition: (row) => row.Id != 99999
        },
        {
          label: "Calcular Meses",
          command: "calc-row-cashflow",
          icon: "el-icon-refresh",
          condition: (row) => row.Id != 99999
        },
        {
          label: "Proyectar",
          command: "looking-forward",
          icon: "el-icon-video-camera",
          condition: (row) => row.Id != 99999
        }
      ],
      columns: [
        {
          prop: "Concept",
          label: "Concepto",
          resizable: true,
          minWidth: 260,
          fixed: false
        },
        {
          prop: "Month1",
          label: "Enero",
          minWidth: 150,
          formatter: CashFlow2Hyperlink,
          attrs: {
            openDrawer: this.OpenDetailDrawer
          }
        },
        {
          prop: "Month2",
          label: "Febrero",
          minWidth: 150,
          formatter: CashFlow2Hyperlink,
          attrs: {
            openDrawer: this.OpenDetailDrawer
          }
        },
        {
          prop: "Month3",
          label: "Marzo",
          minWidth: 150,
          formatter: CashFlow2Hyperlink,
          attrs: {
            openDrawer: this.OpenDetailDrawer
          }
        },
        {
          prop: "Month4",
          label: "Abril",
          minWidth: 150,
          formatter: CashFlow2Hyperlink,
          attrs: {
            openDrawer: this.OpenDetailDrawer
          }
        },
        {
          prop: "Month5",
          label: "Mayo",
          minWidth: 150,
          formatter: CashFlow2Hyperlink,
          attrs: {
            openDrawer: this.OpenDetailDrawer
          }
        },
        {
          prop: "Month6",
          label: "Junio",
          minWidth: 150,
          formatter: CashFlow2Hyperlink,
          attrs: {
            openDrawer: this.OpenDetailDrawer
          }
        },
        {
          prop: "Month7",
          label: "Julio",
          minWidth: 150,
          formatter: CashFlow2Hyperlink,
          attrs: {
            openDrawer: this.OpenDetailDrawer
          }
        },
        {
          prop: "Month8",
          label: "Agosto",
          minWidth: 150,
          formatter: CashFlow2Hyperlink,
          attrs: {
            openDrawer: this.OpenDetailDrawer
          }
        },
        {
          prop: "Month9",
          label: "Septiembre",
          minWidth: 150,
          formatter: CashFlow2Hyperlink,
          attrs: {
            openDrawer: this.OpenDetailDrawer
          }
        },
        {
          prop: "Month10",
          label: "Octubre",
          minWidth: 150,
          formatter: CashFlow2Hyperlink,
          attrs: {
            openDrawer: this.OpenDetailDrawer
          }
        },
        {
          prop: "Month11",
          label: "Noviembre",
          minWidth: 150,
          formatter: CashFlow2Hyperlink,
          attrs: {
            openDrawer: this.OpenDetailDrawer
          }
        },
        {
          prop: "Month12",
          label: "Diciembre",
          minWidth: 150,
          formatter: CashFlow2Hyperlink,
          attrs: {
            openDrawer: this.OpenDetailDrawer
          }
        }
        // {
        //   prop: "Total",
        //   label: "Total",
        //   sortable: false,
        //   minWidth: 150,
        //   formatter: this.mountFormatter
        // }
      ],
      typePronosticoList: [
        {
          label: "Ejecutados",
          value: 0
        },
        {
          label: "Planificación",
          value: 1
        }
      ]
    };
  },
  created() {
    this.companyFilter = this.currentCompany;
    this.getData();
  },

  mounted() {
    this.$refs.yearSelector.$data.Year = yearNow;
  },

  methods: {
    _commonGetSummaries(parameter, title) {
      return {
        ...parameter,
        renderIndex: 1,
        renderText: title,
        emptyText: "",
        formatMount: (val) => this.mountFormatter(undefined, undefined, val)
      };
    },

    ingresoGetSummaries(parameter) {
      return getSummaries(this._commonGetSummaries(parameter, "Ingreso Total"));
    },

    egresoGetSummaries(parameter) {
      return getSummaries(this._commonGetSummaries(parameter, "Egreso Total"));
    },

    getData() {
      return new Promise((resolve, reject) => {
        this.loading = true;
        this.logingText = "Cargando...";
        this.$http
          .get("/api/cashflow/Table", {
            timeout: 3 * 60 * 1000,
            params: {
              Company: this.companyFilter,
              Currency: "USD",
              Year: this.year,
              state: this.state,
              TypePronostico: this.typePronostico
            }
          })
          .then(({ data }) => {
            this.rows = data.Items;
            resolve(data.Items);
          })
          .catch((error) => {
            this.message.error("Erro!");
            console.error(error);
            reject(error);
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    mountFormatter(row, column, cellValue) {
      const formatter = new Intl.NumberFormat(
        "en-US" /*, {
        style: "currency",
        currency: "USD"
      }*/
      );
      return cellValue > 0 ? formatter.format(cellValue) : "";
    },
    handleCommand({ command, row, column }) {
      //console.log("column on handleCommand: ", column);
      const actions = {
        "add-account": () => {
          this.$refs.addAccount.show(row);
        },
        "view-accounts": () => {
          this.$refs.viewAccounts.show(row, column, null);
        },
        "edit-row-cashflow": () => {
          this.$refs.rowCashFlowForm.show(row);
        },
        "delete-row-cashflow": () => {
          this.deleteRenglon(row.Id);
        },
        "calc-row-cashflow": () => {
          this.onRefresh(row.Id);
        },
        "looking-forward": () => {
          this.lookingForward(row.Id);
        }
      };

      actions[command]();

      return;
    },
    OpenDetailDrawer(row, column, month) {
      //console.log("OpenDetailDrawer row: ", row, "\ncolumn: ", column,  "\nmonth: ", month);
      if (row.Id === -7) {
        this.showActiveContracts = true;
      } else {
        this.DetailMonth = month;
        this.$refs.viewAccounts.show(row, column);
      }
    },
    callNew() {
      this.$refs.rowCashFlowForm.show(undefined, this.companyFilter);
    },
    handleryear(_year) {
      this.year = _year;
      this.getData();
    },
    handlerPronostic(pronostic) {
      this.typePronostico = pronostic;
      this.getData();
    },
    handleCompanyChange(company) {
      if (company) {
        this.companyFilter = company;
      } else {
        this.companyFilter = "ALL";
      }
      this.getData();
    },
    deleteRenglon(val) {
      this.$confirm(
        "Esto es permanent, esto elimina el renglon y todas sus proyecciones al igual que todas sus cuentas, esta seguro de esto?",
        "Cuidado!",
        {
          type: "warning",
          confirmButtonText: "Si",
          cancelButtonText: "No"
        }
      )
        .then((response) => {
          if (response === "confirm") {
            this.$http
              .delete("/api/CashFlow", {
                params: {
                  ID: val
                }
              })
              .then(({ data }) => {
                if (data == true) {
                  this.getData();
                  this.$notify.success({
                    duration: 5000,
                    message: "Renglón eliminado",
                    title: "Información",
                    position: "top-left"
                  });
                }
              })
              .catch((error) => {
                this.$message.error("Error al consultar los Registros");
                console.error(error);
              });
          }
        })
        .catch((response) => {
          if (response === "cancel") {
            this.$notify.success({
              duration: 5000,
              message: "Renglón no eliminado",
              title: "Información",
              position: "top-left"
            });
          }
        });
    },
    handleRefresh(state) {
      //console.log("state: ", state)
      this.loading = true;
      this.loadingText = "Re-calculando valores...";
      this.$http
        .post(
          "/api/CashFlow/RefreshTable",
          {},
          {
            timeout: 3 * 60 * 1000,
            params: {
              Company: this.companyFilter,
              Currency: "USD",
              Year: this.year,
              state: state
            }
          }
        )
        .then(() => {
          this._refreshData();
        })
        .catch((error) => {
          this.$message.error("Error al consultar los Registros");
          console.error(error);
        })
        .finally(() => {
          this.loading = true;
        });

      this.$notify.info({
        duration: 5000,
        message: "Proceso de actualizacion iniciado, por favor se paciente.",
        title: "Información",
        position: "top-left"
      });
    },
    _calcRowCashflow(Id) {
      let self = this;
      return new Promise((resolve, reject) => {
        self.$http
          .post(
            "/api/CashFlow/CalcMonthsRowCashflow",
            {},
            {
              params: { Id }
            }
          )
          .then(() => {
            self.$notify.info({
              duration: 5000,
              message: `El renglon id '${Id}' fue recalculado`,
              title: "Información",
              position: "top-left"
            });
            resolve();
          })
          .catch((error) => {
            self.$message.error(`Error al recalcular el renglon id '${Id}'`);
            console.error(error);
            reject(error);
          });
      });
    },

    onRefresh(Id) {
      if (Id !== undefined) {
        this._calcRowCashflow(Id).then(() => {
          this._refreshData();
        });
      } else {
        this._refreshData();
      }
    },

    lookingForward(Id) {
      this._helpHttpPost({
        url: "/api/CashFlow/RenglonLookingForward",
        data: { RenglonID: Id },
        successCalback: function (data) {
          if (data) {
            this.$message.success("Proyeccion exita");
          } else {
            this.$message.warning("Que paso ?");
          }
        }
      });

      /*
      this.$http
        .post("/api/CashFlow/RenglonLookingForward", { RenglonID: Id })
        .then((data) => {
          if (data) {
            this.$message.success("Proyeccion exita");
          } else {
            this.$message.warning("Que paso ?");
          }
        })
        .catch((error) => {
          this.$message.warning("Proyeccion fallida");
          console.error(error);
        });
       */
    },

    _refreshData() {
      this.getData().then(() => {
        this.$notify.success({
          duration: 5000,
          message: "Renglones actualizado",
          title: "Información",
          position: "top-left"
        });
      });
    },

    tableRowClassName({ row }) {
      console.log(
        "Nombre de clases que llevara los colores",
        row.Id,
        row.Concept
      );

      if (row.Id === -1) {
        return "project-row cf-bold";
      }

      if (row.Id === -8) {
        return "available-row cf-bold";
      }

      if (row.Id === -6 || row.Id === -7 || row.Id === 0) {
        return "warning-row cf-bold";
      }

      if (row.Id === -5) {
        return "warning-row-sub";
      }

      if (row.Id === -3 || row.Id === -4) {
        return "success-row cf-bold ";
      }

      if (
        row.Id === -2 ||
        row.Id === -404 ||
        row.Id === -101 ||
        row.Id === -201 ||
        row.Id === -202 ||
        row.Id === -303 ||
        row.Id === -404
      ) {
        return "success-row-sub";
      }

      return "";
      // return "";
    },

    _helpHttpPost({ url, data, successCalback, errorCalback }) {
      return new Promise((resolve, reject) => {
        this.$http
          .post(url, data)
          .then(({ data }) => {
            if (successCalback !== undefined) {
              successCalback.call(this, data);
            }
            resolve(data);
          })
          .catch((error) => {
            if (errorCalback !== undefined) {
              errorCalback.call(this, error);
            }
            console.error(error);
            reject(error);
          });
      });
    },

    OnCloseContractsDetails(event) {
      event;
      //console.log('event: ',event)
      this.showActiveContracts = false;
    }
  }
};
</script>

<!-- V01 -->
<!--<style>
/* row - total de egresos */
.el-table .el-table__body tr.warning-row > td {
  background-color: #e6a23c;
}
.el-table--striped .el-table__body tr.el-table__row--striped.warning-row td {
  background-color: #e6a23c;
}

/* row - total de ingresos */
.el-table .el-table__body tr.success-row > td {
  background-color: #67c23a;
}
.el-table--striped .el-table__body tr.el-table__row--striped.success-row td {
  background-color: #67c23a;
}

/* row - total disponible */
.el-table .el-table__body tr.available-row > td {
  background-color: #409eff;
}
.el-table--striped .el-table__body tr.el-table__row--striped.available-row td {
  background-color: #409eff;
}

.el-table .el-table__body tr.cf-bold .cell {
  font-weight: 900;
  color: #0b0b0c;
}
.el-table [class*="el-table__row--level"].cf-bold .el-table__expand-icon > i {
  font-weight: 900;
  color: #0b0b0c;
}
</style>-->

<!-- V02 -->
<style>
/* row - total de egresos */
.el-table .el-table__body tr.warning-row > td {
  background-color: #fdf6ec;
}
.el-table--striped .el-table__body tr.el-table__row--striped.warning-row td {
  background-color: #fdf6ec;
}
.el-table .el-table__body tr.warning-row .cell {
  font-weight: 900;
  color: #e6a23c;
}
.el-table
  [class*="el-table__row--level"].warning-row
  .el-table__expand-icon
  > i {
  font-weight: 900;
  color: #e6a23c;
}

.el-table .el-table__body tr.warning-row-sub > td {
  background-color: #fdf6ec;
}
.el-table--striped
  .el-table__body
  tr.el-table__row--striped.warning-row-sub
  td {
  background-color: #fdf6ec;
}
.el-table .el-table__body tr.warning-row-sub .cell {
  /* font-weight: 900; */
  color: #e6a23c;
}
.el-table
  [class*="el-table__row--level"].warning-row-sub
  .el-table__expand-icon
  > i {
  /* font-weight: 900; */
  color: #e6a23c;
}

/* row - total de ingresos */
.el-table .el-table__body tr.success-row > td {
  background-color: #f0f9eb;
}
.el-table--striped .el-table__body tr.el-table__row--striped.success-row td {
  background-color: #f0f9eb;
}
.el-table .el-table__body tr.success-row .cell {
  font-weight: 900;
  color: #67c23a;
  font-size: 14px;
}
.el-table
  [class*="el-table__row--level"].success-row
  .el-table__expand-icon
  > i {
  font-weight: 900;
  color: #67c23a;
  font-size: 14px;
}

.el-table .el-table__body tr.success-row-sub > td {
  background-color: #f0f9eb;
}
.el-table--striped
  .el-table__body
  tr.el-table__row--striped.success-row-sub
  td {
  background-color: #f0f9eb;
}
.el-table .el-table__body tr.success-row-sub .cell {
  /* font-weight: 900; */
  color: #67c23a;
  font-size: 12px;
}
.el-table
  [class*="el-table__row--level"].success-row-sub
  .el-table__expand-icon
  > i {
  /* font-weight: 900; */
  color: #67c23a;
  font-size: 12px;
}

/* row - total disponible */
.el-table .el-table__body tr.available-row > td {
  background-color: rgb(198, 226, 255);
}
.el-table--striped .el-table__body tr.el-table__row--striped.available-row td {
  background-color: rgb(198, 226, 255);
}
.el-table .el-table__body tr.available-row .cell {
  font-weight: 900;
  color: #409eff;
}
.el-table
  [class*="el-table__row--level"].available-row
  .el-table__expand-icon
  > i {
  font-weight: 900;
  color: #409eff;
}

/* row - total de proyecto */
.el-table .el-table__body tr.project-row > td {
  background-color: rgb(233, 233, 235);
}

.el-table--striped .el-table__body tr.el-table__row--striped.project-row td {
  background-color: rgb(233, 233, 235);
}
.el-table .el-table__body tr.project-row .cell {
  font-weight: 900;
  color: #909399;
}
.el-table
  [class*="el-table__row--level"].project-row
  .el-table__expand-icon
  > i {
  font-weight: 900;
  color: #909399;
}
</style>

<!-- V03 -->
<!-- <style>
/* row - total de egresos */
.el-table .el-table__body tr.warning-row > td {
  background-color: #fdf6ec;
}
.el-table--striped .el-table__body tr.el-table__row--striped.warning-row td {
  background-color: #fdf6ec;
}

/* row - total de ingresos */
.el-table .el-table__body tr.success-row > td {
  background-color: #f0f9eb;
}
.el-table--striped .el-table__body tr.el-table__row--striped.success-row td {
  background-color: #f0f9eb;
}

/* row - total disponible */
.el-table .el-table__body tr.available-row > td {
  background-color: rgb(198, 226, 255);
}
.el-table--striped .el-table__body tr.el-table__row--striped.available-row td {
  background-color: rgb(198, 226, 255);
}
</style> -->
